import React from "react";
import "./Intro.css";
import Github from "../../img/github.png";
import Linkedin from "../../img/linkedin.png";
import Instagram from "../../img/instagram.png";
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/Vector2.png";
import girlme from "../../img/girlme.png";
import thumbup from "../../img/thumbup.png";
import Crown from "../../img/crown.png";
import glassesimoji from "../../img/glassesimoji.png";
import FloatingDiv from "../FloatingDiv/FloatingDiv";
import Resume from "../Services/resume.pdf";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

export const Intro = () => {
  const transition = { duration: 2, type: "spring" };
  const reduceMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <section className="intro section">
      <div className="intro-inner container">
        <div className="i-left">
          <div className="i-name">
            <span>Bonjour ! Je suis</span>
            <span>Adèle Manga</span>
            <span>
              Développeuse fullstack spécialisée dans la conception
              d&apos;applications web modernes, performantes et adaptées aux
              besoins de chaque projet.
            </span>
          </div>

          <div className="i-actions">
            <a className="button i-button" href={Resume} download>
              Télécharger CV
            </a>
            <Link spy smooth offset={-80} to="Contact">
              <button type="button" className="button button-secondary i-button">
                Me contacter
              </button>
            </Link>
          </div>

          <div className="i-icons">
            <a
              href="https://github.com/adelemanga"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <img src={Github} alt="" />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <img src={Linkedin} alt="" />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <img src={Instagram} alt="" />
            </a>
          </div>
        </div>

        <div className="i-right">
          <img className="i-vector i-vector-1" src={Vector1} alt="" />
          <img className="i-vector i-vector-2" src={Vector2} alt="" />
          <img className="i-portrait" src={girlme} alt="Adèle Manga" />
          <motion.img
            className="i-emoji"
            initial={reduceMotion ? false : { left: "-36%" }}
            whileInView={reduceMotion ? undefined : { left: "-24%" }}
            transition={transition}
            src={glassesimoji}
            alt=""
          />
          <motion.div
            className="floating-div floating-div-top"
            initial={reduceMotion ? false : { top: "-4%", left: "74%" }}
            whileInView={reduceMotion ? undefined : { left: "58%" }}
            transition={transition}
            style={{ top: "-4%", left: "58%" }}
          >
            <FloatingDiv image={Crown} txt1="Web" txt2="Developer" />
          </motion.div>
          <motion.div
            className="floating-div floating-div-bottom"
            initial={reduceMotion ? false : { left: "9rem", top: "18rem" }}
            whileInView={reduceMotion ? undefined : { left: "0rem" }}
            transition={transition}
            style={{ top: "18rem", left: "0rem" }}
          >
            <FloatingDiv image={thumbup} txt1="Best Design" txt2="Award" />
          </motion.div>
          <div className="blur" style={{ background: "rgb(238 210 255)" }} />
          <div
            className="blur"
            style={{
              background: "#C1F5FF",
              top: "17rem",
              width: "21rem",
              height: "11rem",
              left: "-9rem",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default Intro;
